import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import { selectStep } from '../../../actions/gameGuideActions';
import Sign from '../sign';

class GameGuideNavLink  extends React.Component {
    handleClick = () => {
        const { dispatch } = this.props;
        const { step } = this.props;

        // dispatch event to select step
        dispatch(selectStep(step));
    }

    render () {
        const { gameGuide, title, step, locked } = this.props;
        const { currentStep, maxStep } = gameGuide;

        let classNames = '';
        if(step === currentStep) {
            classNames = 'active';
        }

        let isLocked = locked;
        if(isLocked === null || isLocked === undefined) {
            isLocked = !(step <= gameGuide.maxStep);
        } 
        
        if(isLocked) {
            classNames = 'locked';
        }
        
        const fnClick = step <= maxStep 
            ? this.handleClick
            : () => {}
        ;

        return (
            <Sign 
                content={title}
                onClick={fnClick}
                className={classNames}
                locked={isLocked}
            />
        );
    };
}

GameGuideNavLink.defaultProperties = {
    title: '',
    step: 0,
    locked: null
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameGuideNavLink);